<template>
  <span>
    <v-card outlined>
      <v-card-text>
        <div class="overline"><h2>Match Summary</h2></div>
        <v-row dense>
          <v-col> </v-col>
          <v-col><b>Case Data</b></v-col>
          <v-col> </v-col>
          <v-col><b>Sanction Data</b></v-col>
        </v-row>
        <v-row
          v-for="(similarField, index) in summary.matchFields"
          :key="index"
          dense
          align="center"
        >
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col cols="1">{{ similarField.fieldName }}</v-col>
          <v-col>
            <span v-if="similarField.caseFieldNote" class="overline">
              {{ similarField.caseFieldNote }}
              <br />
            </span>
            {{ similarField.caseField }}
          </v-col>
          <v-col align="center">
            <v-chip
              v-if="similarField.similarity == 'STRONG'"
              small
              color="green"
              dark
              class="font-weight-black"
              >=</v-chip
            >
            <v-chip v-else small color="blue lighten-2" dark class="font-weight-black">≈</v-chip>
          </v-col>
          <!-- <v-col>{{ similarField.similarityScore }}</v-col> -->
          <v-col>
            <span v-if="similarField.sanctionFieldNote" class="overline">
              {{ similarField.sanctionFieldNote }}
              <br />
            </span>
            <span class="caps">{{ similarField.sanctionField }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
export default {
  name: "MatchSummary",
  data() {
    return {};
  },
  props: {
    summary: {},
  },
  methods: {},
};
</script>